function initializeCarouselDots() {
  document.querySelectorAll('scroll-carousel').forEach(carousel => {
    const carouselId = carousel.id;
    const items = carousel.querySelectorAll('.product-card, .product-card-placeholder');
    if (!items.length) return;

    const isMobile = window.innerWidth < 700;
    const groupSize = parseInt(
      carousel.dataset.productsPerRowMobile && isMobile
        ? carousel.dataset.productsPerRowMobile || 3
        : carousel.dataset.productsPerRowDesktop || 3,
      10
    );

    const itemWidth = items[0].offsetWidth || 200;
    const scrollAmount = groupSize * itemWidth;
    const totalGroups = Math.ceil(items.length / groupSize);

    const dotContainer = document.querySelector(`.js-dots[data-carousel-id="${carouselId}"]`);
    if (!dotContainer || dotContainer.dataset.processed) return;
    dotContainer.dataset.processed = "true";

    [...Array(totalGroups)].forEach((_, i) => {
      const dot = document.createElement("span");
      dot.className = `dot${i === 0 ? " active" : ""}`;
      dot.dataset.carouselId = carouselId;
      dot.dataset.rowIndex = i;
      dot.addEventListener("click", () => {
        carousel.scrollTo({ left: i * scrollAmount, behavior: "smooth" });
        updateDots(i);
      });
      dotContainer.appendChild(dot);
    });

    const dots = dotContainer.querySelectorAll(".dot");

    const updateDots = (index) => {
      dots.forEach(dot => dot.classList.remove("active"));
      if (dots[index]) dots[index].classList.add("active");
    };

    const onScroll = debounce(() => {
      const index = Math.round(carousel.scrollLeft / scrollAmount);
      updateDots(index);
    }, 100);

    carousel.addEventListener("scroll", onScroll);
  });

  function debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  }
}

// Run the function once on any of the interaction events
const runOnce = () => {
  initializeCarouselDots();
  events.forEach(evt => window.removeEventListener(evt, runOnce));
};

const events = ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'];
events.forEach(evt => {
  window.addEventListener(evt, runOnce, { once: true, passive: true });
});


// // Carousel Dots Functionality

// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll('scroll-carousel').forEach(carousel => {
//     const carouselId = carousel.id;
//     const items = carousel.querySelectorAll('.product-card, .product-card-placeholder');
//     if (!items.length) return;

//     // Detect screen size and pick the appropriate value
//     const isMobile = window.innerWidth < 700;
//     const groupSize = parseInt(
//       carousel.dataset.productsPerRowMobile && isMobile
//         ? carousel.dataset.productsPerRowMobile || 3
//         : carousel.dataset.productsPerRowDesktop || 3,
//       10
//     );

//     const itemWidth = items[0].offsetWidth || 200;
//     const scrollAmount = groupSize * itemWidth;
//     const totalGroups = Math.ceil(items.length / groupSize);

//     const dotContainer = document.querySelector(`.js-dots[data-carousel-id="${carouselId}"]`);
//     if (!dotContainer || dotContainer.dataset.processed) return;
//     dotContainer.dataset.processed = "true";

//     // Create dots
//     [...Array(totalGroups)].forEach((_, i) => {
//       const dot = document.createElement("span");
//       dot.className = `dot${i === 0 ? " active" : ""}`;
//       dot.dataset.carouselId = carouselId;
//       dot.dataset.rowIndex = i;
//       dot.addEventListener("click", () => {
//         carousel.scrollTo({ left: i * scrollAmount, behavior: "smooth" });
//         updateDots(i);
//       });
//       dotContainer.appendChild(dot);
//     });

//     const dots = dotContainer.querySelectorAll(".dot");

//     const updateDots = (index) => {
//       dots.forEach(dot => dot.classList.remove("active"));
//       if (dots[index]) dots[index].classList.add("active");
//     };

//     const onScroll = debounce(() => {
//       const index = Math.round(carousel.scrollLeft / scrollAmount);
//       updateDots(index);
//     }, 100);

//     carousel.addEventListener("scroll", onScroll);
//   });

//   function debounce(fn, delay) {
//     let timer;
//     return (...args) => {
//       clearTimeout(timer);
//       timer = setTimeout(() => fn(...args), delay);
//     };
//   }
// });


document.addEventListener('DOMContentLoaded', function () {
  const gallery = document.querySelector('.product-gallery__carousel');
  const mediaItems = document.querySelectorAll('.product-gallery__media');

  if (gallery && mediaItems.length > 1) {
    gallery.classList.add('--multiple');
  }
});


 document.addEventListener('DOMContentLoaded', function () {
    const headerSticky = document.querySelector('.header');

    if (!headerSticky) return;

    window.addEventListener('scroll', function () {
      if (window.innerWidth <= 999) {
        if (window.scrollY > 150) {
          headerSticky.classList.add('header-fixed');
        } else {
          headerSticky.classList.remove('header-fixed');
        }
      } else {
        // Ensure sticky is removed on desktop
        headerSticky.classList.remove('header-fixed');
      }
    });
  });
